export default __webpack_public_path__ + "static/media/normal-picture-1.df4e4981.png";